import { render, staticRenderFns } from "./goa-taxi-rental.vue?vue&type=template&id=9636e9c6&scoped=true"
import script from "./goa-taxi-rental.vue?vue&type=script&lang=js"
export * from "./goa-taxi-rental.vue?vue&type=script&lang=js"
import style0 from "./goa-taxi-rental.vue?vue&type=style&index=0&id=9636e9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9636e9c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
